// ─────────────────────────────────────────────────────────────────────────────
// Maintenance service — Vendors & Product Lines
//
// FLUJO DE ESCRITURA (create / update / deactivate):
//   El frontend manda SOLO datos de negocio + el "No" (correlativo).
//   La request llega al SERVIDOR LOCAL, que:
//     1) mergea los datos con un archivo de defaults de integración MAS90
//        (vendor.defaults.json / productline.defaults.json) — división, cuentas
//        GL, terms, flags, etc. Esos valores NUNCA viajan desde el frontend.
//     2) genera un Excel con la fila completa.
//     3) ejecuta un .bat que sincroniza con MAS90 vía un job.
//
// Por eso el frontend desconoce los valores del sistema: solo envía el payload
// "limpio". Los endpoints de escritura quedan STUBEADOS (rutas TODO) para que
// backend defina el transporte y la URL final.
// ─────────────────────────────────────────────────────────────────────────────
import { getInformationWithData } from './CABE';
import { getValueCookie } from './cookieService';

const companyId = () =>
    getValueCookie('SubCompanyId')
        ? Number(getValueCookie('SubCompanyId'))
        : Number(getValueCookie('CompanyId'));

// Ajustar estas rutas cuando backend exponga los endpoints definitivos.
export const MAINTENANCE_ENDPOINTS = {
    vendor: {
        list: '/vendors/get/vendorsInformation', // ✅ ya existe
        nextNo: '/vendors/get/nextVendorNo',     // TODO backend
        create: '/vendors/create',               // TODO backend → Excel + .bat
        update: '/vendors/update',               // TODO backend → Excel + .bat
        deactivate: '/vendors/deactivate',       // TODO backend → Excel + .bat
    },
    productLine: {
        list: '/Items/Margin/Alt',               // ✅ ya existe
        nextNo: '/productline/get/nextProductLine', // TODO backend
        create: '/productline/create',           // TODO backend → Excel + .bat
        update: '/productline/update',           // TODO backend → Excel + .bat
        deactivate: '/productline/deactivate',   // TODO backend → Excel + .bat
    },
};

const ok = (res) => res && res.status && res.status.code === 1;

// Extrae el "siguiente número" de la respuesta, tolerando { nextNo } o valor plano.
const extractNextNo = (res) => {
    if (!ok(res)) return null;
    const d = res.data;
    if (d && d.nextNo !== undefined && d.nextNo !== null) return d.nextNo;
    return d;
};

// ─── VENDORS ──────────────────────────────────────────────────────────────────
export const listVendors = async () => {
    const res = await getInformationWithData(MAINTENANCE_ENDPOINTS.vendor.list, { idCompany: companyId() });
    return ok(res) ? res.data : [];
};

// Devuelve el siguiente vendorNo (último registro + 1). STUB hasta que backend lo exponga.
export const getNextVendorNo = async () => {
    const res = await getInformationWithData(MAINTENANCE_ENDPOINTS.vendor.nextNo, { idCompany: companyId() });
    return extractNextNo(res);
};

export const saveVendor = async (payload, isEdit) => {
    const route = isEdit ? MAINTENANCE_ENDPOINTS.vendor.update : MAINTENANCE_ENDPOINTS.vendor.create;
    const res = await getInformationWithData(route, { ...payload, idCompany: companyId(), updateBy: getValueCookie('userName') });
    return ok(res);
};

export const deactivateVendor = async (VendorNo) => {
    const res = await getInformationWithData(MAINTENANCE_ENDPOINTS.vendor.deactivate, { VendorNo, idCompany: companyId(), updateBy: getValueCookie('userName') });
    return ok(res);
};

// ─── PRODUCT LINES ──────────────────────────────────────────────────────────
export const listProductLines = async () => {
    const res = await getInformationWithData(MAINTENANCE_ENDPOINTS.productLine.list, {});
    return ok(res) ? res.data : [];
};

export const getNextProductLine = async () => {
    const res = await getInformationWithData(MAINTENANCE_ENDPOINTS.productLine.nextNo, { idCompany: companyId() });
    return extractNextNo(res);
};

export const saveProductLine = async (payload, isEdit) => {
    const route = isEdit ? MAINTENANCE_ENDPOINTS.productLine.update : MAINTENANCE_ENDPOINTS.productLine.create;
    const res = await getInformationWithData(route, { ...payload, idCompany: companyId(), updateBy: getValueCookie('userName') });
    return ok(res);
};

export const deactivateProductLine = async (productLine) => {
    const res = await getInformationWithData(MAINTENANCE_ENDPOINTS.productLine.deactivate, { productLine, idCompany: companyId(), updateBy: getValueCookie('userName') });
    return ok(res);
};
